<template>
  <article
    class="garage-price-list"
    itemprop="hasOfferCatalog"
    itemscope
    itemtype="http://schema.org/OfferCatalog"
  >
    <GaragePriceCategory
      v-for="category in categories"
      :category="category"
      :currentFilter="currentFilter"
      @show-service-details="emits('show-service-details', $event)"
    />
  </article>
</template>

<script setup lang="ts">

import type { PriceCategoryView, PriceElementView } from '~/api/docs/app';
import { popularCategoryId } from '~/models/consts';

interface IProps {
  garagePriceListWithCategories?: PriceCategoryView[];
  limit?: boolean;
  search?: boolean;
  currentFilter?: string | null;
  contextAB?: boolean;
  sortByScore?: boolean;
}

interface IEmits {
  (name: 'set-other-reason-tab'): void;
  (name: 'show-service-details', value: PriceElementView): void;
}

// props
const props = withDefaults(defineProps<IProps>(), {
  limit: false
});

// emits
const emits = defineEmits<IEmits>();

// use 
const route = useRoute();

// methods
const nuxtLinkTo = (serviceId: string) => {
  return route.meta.layout === 'modal' ? `${route.path}/${serviceId}` : `${route.path}/services/${serviceId}`;
};

// computed
const popularPriceList: ComputedRef<PriceCategoryView> = computed(() => {
  const popularPriceList = props.garagePriceListWithCategories?.map(el => el.priceList?.filter(pl => pl.flags?.popular) || []).flat() || [];

  const popularCategory = {
    id: popularCategoryId,
    name: props.contextAB ? 'Usługi' : 'Popularne usługi',
    priceList: props.sortByScore
      ? popularPriceList.sort((a, b) => (b.score || 0) - (a.score || 0))
      : popularPriceList.sort((a, b) => {
        if ((a.name || '') < (b.name || '')) {
          return -1;
        }
        if ((a.name || '') > (b.name || '')) {
          return 1;
        }
        return 0;
      }),
    shortName: 'Popularne'
  };
  return popularCategory;
});



const categories: ComputedRef<PriceCategoryView[]> = computed(() => {
  if (props.contextAB) {
    if (route.name === 'mechanicy-city-garageId-services') {
      return props.garagePriceListWithCategories || [];
    } else {
      return [popularPriceList.value];
    }
  }

  if (props.search || props.currentFilter !== popularCategoryId) return props.garagePriceListWithCategories || [];

  return [popularPriceList.value, ...props.garagePriceListWithCategories || []];
})

</script>

<style lang="scss" scoped>
@import url('assets/styles/components/garage-price-list.scss');
</style>